import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Form, Formik } from "formik";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import StepRoutes from "../../../Routes/steps_routes";
import CustomInput from "../../../CustomComponent/custom_input";
import CustomSelect from "../../../CustomComponent/custom_select";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import Footer from "../../../Components/Footer/footer";
import LoadingPage from "../../../Components/layouts/loading";
import { pestDiseaseInfo } from "../../../SchemaInfo/info";
import { pestDiseaseScheama } from "../../../Schemas/Agronomy Wiki/pest_disease";
import CustomTextArea from "../../../CustomComponent/custom_textarea";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { useEffect } from "react";
import { MdPestControl } from "react-icons/md";

const EditPestDisease = () => {
  const [pestDisease, setPestDisease] = useState(pestDiseaseInfo);
  const [loading, setLoading] = useState(false);
  let { id } = useParams();
  const navigate = useNavigate();

  const handelSubmit = (values, actions) => {
    const formData = new FormData();
    for (let key in values) {
      formData.append(key, values[key]);
    }
    setLoading(true);
    performRequest("PATCH", `/pestDisease/updatePestDisease/${id}`, formData, {
      "Content-Type": "multipart/form-data",
    })
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Pest/Disease updated successfully!");
          navigate(`/agronomy-pest-disease/view/${id}`);
        } else {
          Toast("error", "Error while uploading");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/pestDisease/getPestDiseaseById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setPestDisease(res.data);
        } else {
          Toast("error", "Error while getting data!");
        }
        setLoading(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">Pest Disease Tracking</h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">
                <MdPestControl className="me-2" style={{ color: "brown" }} />
                Edit pest/disease
              </h2>
            </div>
            <Formik
              initialValues={pestDisease}
              validationSchema={pestDiseaseScheama}
              onSubmit={handelSubmit}
            >
              {(props) => (
                <Form>
                  <div className="card-body">
                    <div className="mb-3 row">
                      <label className="w-25 form-label required col-3">
                        Name
                      </label>
                      <div className="w-100 col">
                        <CustomInput name="diseasesName" type="text" />
                        {props.touched.diseasesName &&
                          props.errors.diseasesName && (
                            <p className="text-danger">
                              {props.errors.diseasesName}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label  col-3">
                        Photo of pest/disease
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="image"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue("image", e.target.files[0])
                          }
                        />
                        {props.touched.image && props.errors.image && (
                          <p className="text-danger">{props.errors.image}</p>
                        )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label required col-3 ">
                        Type of disease
                      </label>
                      <div className="w-100 col">
                        <CustomSelect type="text" name="typeOfDiseases">
                          <option value="">Select</option>
                          <option value="pest">Pest</option>
                          <option value="disease">Disease</option>
                        </CustomSelect>
                        {props.touched.typeOfDiseases &&
                          props.errors.typeOfDiseases && (
                            <p className="text-danger">
                              {props.errors.typeOfDiseases}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label  col-3">
                        Description
                      </label>
                      <div className="w-100 col">
                        <CustomTextArea name="description" type="text" />
                        {props.touched.description &&
                          props.errors.description && (
                            <p className="text-danger">
                              {props.errors.description}
                            </p>
                          )}
                      </div>
                    </div>
                    <hr className="mb-2" />
                    <h3>* Basic pest-control</h3>
                    <hr className="mt-0" />
                    <div className="mb-3 row">
                      <label className="w-25 form-label  col-3">
                        Product To Use
                      </label>
                      <div className="w-100 col">
                        <CustomTextArea name="productToUse" type="text" />
                        {props.touched.productToUse &&
                          props.errors.productToUse && (
                            <p className="text-danger">
                              {props.errors.productToUse}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label  col-3">
                        Product photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="productPhoto"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "productPhoto",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.productPhoto &&
                          props.errors.productPhoto && (
                            <p className="text-danger">
                              {props.errors.productPhoto}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label  col-3">
                        Product link
                      </label>
                      <div className="w-100 col">
                        <CustomInput name="productLink" type="text" />
                        {props.touched.productLink &&
                          props.errors.productLink && (
                            <p className="text-danger">
                              {props.errors.productLink}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label  col-3">
                        Usage Of Product
                      </label>
                      <div className="w-100 col">
                        <CustomInput name="usageOfProduct" type="text" />
                        {props.touched.usageOfProduct &&
                          props.errors.usageOfProduct && (
                            <p className="text-danger">
                              {props.errors.usageOfProduct}
                            </p>
                          )}
                      </div>
                    </div>
                    <hr className="mb-2" />
                    <h3>* Moderate pest-control</h3>
                    <hr className="mt-0" />
                    <div className="mb-3 row">
                      <label className="w-25 form-label  col-3">
                        Product To Use
                      </label>
                      <div className="w-100 col">
                        <CustomTextArea
                          name="productToUseModerate"
                          type="text"
                        />
                        {props.touched.productToUseModerate &&
                          props.errors.productToUseModerate && (
                            <p className="text-danger">
                              {props.errors.productToUseModerate}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label  col-3">
                        Product photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="productPhotoModerate"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "productPhotoModerate",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.productPhotoModerate &&
                          props.errors.productPhotoModerate && (
                            <p className="text-danger">
                              {props.errors.productPhotoModerate}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label  col-3">
                        Product link
                      </label>
                      <div className="w-100 col">
                        <CustomInput name="productLinkModerate" type="text" />
                        {props.touched.productLinkModerate &&
                          props.errors.productLinkModerate && (
                            <p className="text-danger">
                              {props.errors.productLinkModerate}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label  col-3">
                        Usage Of Product
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="usageOfProductModerate"
                          type="text"
                        />
                        {props.touched.usageOfProductModerate &&
                          props.errors.usageOfProductModerate && (
                            <p className="text-danger">
                              {props.errors.usageOfProductModerate}
                            </p>
                          )}
                      </div>
                    </div>{" "}
                    <hr className="mb-2" />
                    <h3>* Wild-spred pest-control</h3>
                    <hr className="mt-0" />
                    <div className="mb-3 row">
                      <label className="w-25 form-label  col-3">
                        Product To Use
                      </label>
                      <div className="w-100 col">
                        <CustomTextArea name="productToUseWild" type="text" />
                        {props.touched.productToUseWild &&
                          props.errors.productToUseWild && (
                            <p className="text-danger">
                              {props.errors.productToUseWild}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label  col-3">
                        Product photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="productPhotoWild"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "productPhotoWild",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.productPhotoWild &&
                          props.errors.productPhotoWild && (
                            <p className="text-danger">
                              {props.errors.productPhotoWild}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label  col-3">
                        Product link
                      </label>
                      <div className="w-100 col">
                        <CustomInput name="productLinkWild" type="text" />
                        {props.touched.productLinkWild &&
                          props.errors.productLinkWild && (
                            <p className="text-danger">
                              {props.errors.productLinkWild}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label  col-3">
                        Usage Of Product
                      </label>
                      <div className="w-100 col">
                        <CustomInput name="usageOfProductWild" type="text" />
                        {props.touched.usageOfProductWild &&
                          props.errors.usageOfProductWild && (
                            <p className="text-danger">
                              {props.errors.usageOfProductWild}
                            </p>
                          )}
                      </div>
                    </div>{" "}
                    <hr className="mb-2" />
                    <h3>Organic pest-control</h3>
                    <hr className="mt-0" />
                    <div className="mb-3 row">
                      <label className="w-25 form-label  col-3">
                        Product To Use
                      </label>
                      <div className="w-100 col">
                        <CustomTextArea
                          name="productToUseOrganic"
                          type="text"
                        />
                        {props.touched.productToUseOrganic &&
                          props.errors.productToUseOrganic && (
                            <p className="text-danger">
                              {props.errors.productToUseOrganic}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label  col-3">
                        Product photo
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name="productPhotoOrganic"
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "productPhotoOrganic",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.productPhotoOrganic &&
                          props.errors.productPhotoOrganic && (
                            <p className="text-danger">
                              {props.errors.productPhotoOrganic}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label  col-3">
                        Product link
                      </label>
                      <div className="w-100 col">
                        <CustomInput name="productLinkOrganic" type="text" />
                        {props.touched.productLinkOrganic &&
                          props.errors.productLinkOrganic && (
                            <p className="text-danger">
                              {props.errors.productLinkOrganic}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label  col-3">
                        Usage Of Product
                      </label>
                      <div className="w-100 col">
                        <CustomInput name="usageOfProductOrganic" type="text" />
                        {props.touched.usageOfProductOrganic &&
                          props.errors.usageOfProductOrganic && (
                            <p className="text-danger">
                              {props.errors.usageOfProductOrganic}
                            </p>
                          )}
                      </div>
                    </div>
                  </div>
                  <div className="card-footer">
                    <div className="btn-list justify-content-end">
                      <FormSubmitButton buttonText="Save Pest/Disease" />
                      <SimpleButton buttonText="Cancel" type="secondary" />
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default EditPestDisease;
